import MultiSelect from '@sophocles/components/MultiSelect/MultiSelect';

export default MultiSelect;
